module.exports = __webpack_public_path__ + "static/media/pmi.3444a1cb.png";